<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

  <div class="container3 cent" style="margin-top:60px" *ngIf=" adoprequestflag === 0 && puserflag === 0;">
    <div class="card" *ngIf="formstatus == 0; else uploaded">
      <div class="card-header">
        <div class="row">
          <div class="col-12 text-center">
              <span style="color: #9b7544; font-style: open sans; font-size:22px;
               overflow-wrap: break-word;">
               Adoption request Form
              </span>
          </div>
        </div>
      </div>
      <div class="card-body" style="font-style: open sans">
        <form [formGroup]="adoptionform"  (ngSubmit)="postForAdoptionRequest(f)" #f="ngForm">
          <div class="row" *ngIf="lastadoptionformid">
            <div class="col-12 text-center" (click)="getpreviousFormDetail()">
              <a><span style="color: #9b7544; font-style: open sans; font-size:22px;
              overflow-wrap: break-word; text-decoration: underline; cursor: pointer">Click Here to Autofill Data From Earlier Adoption Form</span></a>
              </div>

              </div>
            <div class="card-header">
                <div class="row">
                  <div class="col-12 text-center">
                      <span style="color: #9b7544; font-style: open sans; font-size:22px;
                       overflow-wrap: break-word;">
                       Personal Details
                      </span>
                  </div>
                </div>
              </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                <div class="form-group">
                    <label for="name">  Name</label>
                    <input type="text" name="name" id="name" [(ngModel)]="adoptionform.uname"
                     class="form-control" formControlName="uname">
                    </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                <div class="form-group">
                    <label for="email">  Email</label>
                    <input type="text" name="email" id="email" [(ngModel)]="adoptionform.uemail"
                    class="form-control" formControlName="uemail">
                    </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                  <div class="form-group">
                      <label for="mobile">Mobile</label>
                      <input type="text" name="mobile" id="mobile" [(ngModel)]="adoptionform.umobile"
                      class="form-control" formControlName="umobile">
                      </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                  <div class="form-group">
                      <label for="dob">Date Of Birh</label>
                      <input type="date" name="dob" id="dob"  class="form-control"
                      [(ngModel)]= "adoptionform.dob" formControlName="dob">
                      </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                    <div class="form-group" *ngIf="state">
                        <label for="state">State</label>
                        <select formControlName="state"  [(ngModel)]= "adoptionform.state"
                        class="form-control" formControlName="state">
                            <option *ngFor="let data of state" value="{{data.id}}">{{data.name}}</option>
                            </select>
                        </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                    <div class="form-group" *ngIf="city">
                        <label for="city">City</label>
                        <select   name="city" id="city" [(ngModel)]= "adoptionform.city"
                         class="form-control" formControlName="city">
                            <option *ngFor="let data of city" value="{{data.id}}">{{data.location}}</option>
                            </select>
                        </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                      <div class="form-group">
                          <label for="pin">Postal Code</label>
                          <input type="number" name="pin" id="pin" [(ngModel)]= "adoptionform.pin"
                           class="form-control" formControlName="pin">
                          </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6col-xl-6">
                      <div class="form-group">
                          <label for="prof">Your Profession</label>
                          <input type="text" name="prof" id="prof" [(ngModel)]= "adoptionform.prof"
                          class="form-control" formControlName="prof">
                          </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-12">
                      <div class="form-group">
                          <label for="btf">Best Time To call</label>
                          <input type="text" name="btf" id="btf" [(ngModel)]= "adoptionform.btf"
                           class="form-control" formControlName="btf">
                          </div>
                    </div>
                  </div>
                  <div class="card-header">
                      <div class="row">
                        <div class="col-12 text-center">
                            <span style="color: #9b7544; font-style: open sans; font-size:22px;
                             overflow-wrap: break-word;">
                             HouseHold Details
                            </span>
                        </div>
                      </div>
                    </div>
                    <div class="card-body" style="font-style: open sans">
                      <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="q1">Are all members of your household in agreement on adopting a pet ??</label>
                                <select name="q1" id="q1" [(ngModel)]= "adoptionform.q1"
                                class="form-control" formControlName="q1">
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                </select>

                                </div>
                        </div>
                      </div>
                      <div class="row">
                          <div class="col-12">
                              <div class="form-group">
                                  <label for="q2">Who Will be the primary caretaker of the adopted pet?</label>
                                  <select  name="q2" id="q2" [(ngModel)]= "adoptionform.q2"
                                  class="form-control" formControlName="q2">
                                    <option value="Me">Me</option>
                                    <option value="somebody else">Somebody Else</option>
                                  </select>
                                  </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                              <div class="form-group">
                                  <label for="q3">Do you live in a</label>
                                  <select  name="q3" id="q3" [(ngModel)]= "adoptionform.q3"
                                  class="form-control" formControlName="q3">
                                    <option value="House">House</option>
                                    <option value="Apartment">Apartment</option>
                                    <option value="Villa">Villa</option>
                                    <option value="Apartment">Others</option>
                                  </select>
                                  </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                              <div class="form-group">
                                  <label for="q4">Your home is</label>
                                  <select  name="q4" id="q4" [(ngModel)]= "adoptionform.q4"
                                  class="form-control" formControlName="q4">
                                    <option value="Rented">Rented</option>
                                    <option value="Owned">Owned</option>
                                  </select>
                                  </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="form-group">
                                    <label for="q5">No of people (in addition to you) in your house</label>
                                    <input type="text" name="q5" id="q5" [(ngModel)]= "adoptionform.q5"
                                     class="form-control" formControlName="q5">
                                    </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="form-group">
                                    <label for="q6">No of children in your house</label>
                                    <input type="text" name="q6" id="q6" [(ngModel)]= "adoptionform.q6"
                                     class="form-control" formControlName="q6">
                                    </div>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                  <div class="form-group">
                                      <label for="q7">Where will the pet be kept</label>
                                      <select  name="q7" id="q7" [(ngModel)]= "adoptionform.q7"
                                       class="form-control" formControlName="q7">
                                        <option value="inside a kennel/cage">inside a kennel/cage</option>
                                        <option value="covered balcony or porch">covered balcony or porch</option>
                                        <option value="Inside the House or apartment">Inside the House or apartment</option>
                                        <option value="Tied outside the house">Tied outside the house</option>
                                      </select>
                                      </div>
                              </div>
                              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                  <div class="form-group">
                                      <label for="q8">Are there any restriction in your house/apartment/villa
                                        association for keeping pets
                                      </label>
                                      <select  name="q8" id="q8" [(ngModel)]= "adoptionform.q8"
                                       class="form-control" formControlName="q8">
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </select>
                                      </div>
                                </div>
                            </div>
                      </div>
                      <div class="card-header">
                          <div class="row">
                            <div class="col-12 text-center">
                                <span style="color: #9b7544; font-style: open sans; font-size:22px;
                                 overflow-wrap: break-word;">
                                 Caretaker Details
                                </span>
                            </div>
                          </div>
                        </div>
                      <div class="row">
                          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                              <div class="form-group">
                                  <label for="q9">Have you owned a pet before</label>
                                  <select  name="q9" id="q9" [(ngModel)]= "adoptionform.q9"
                                  class="form-control" formControlName="q9">
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                  </select>
                                  </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="adoptionform.q9 === 'yes'">
                              <div class="form-group">
                                  <label for="q10">If yes share details</label>
                                  <textarea class="row-5" name="q10" id="q10" [(ngModel)]= "adoptionform.q10"
                                   class="form-control" formControlName="q10"></textarea>
                                  </div>
                          </div>
                          </div>
                          <div class="row">
                              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                  <div class="form-group">
                                      <label for="q11">Do you currently own any other pets?</label>
                                      <select  name="q11" id="q11" [(ngModel)]= "adoptionform.q11"
                                       class="form-control" formControlName="q11">
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </select>
                                      </div>
                              </div>
                              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="adoptionform.q11 === 'yes'">
                                  <div class="form-group">
                                      <label for="q12">If yes share details</label>
                                      <textarea class="row-5"  name="q12" id="q12" [(ngModel)]="adoptionform.q12"
                                      class="form-control" formControlName="q12"></textarea>
                                      </div>
                              </div>
                              </div>
                              <div class="row">
                                  <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                      <div class="form-group">
                                          <label for="q13">How much time in a day are you willing to provide to the pet (eg for training/ walks etc)</label>
                                          <input type="text" name="q13" id="q13" [(ngModel)]= "adoptionform.q13"
                                            class="form-control" formControlName="q13">
                                  </div>
                                  </div>
                                  <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                      <div class="form-group">
                                          <label for="q14">Will you be able to take care of all expenses(Medical/Food etc) for your adopted pet?</label>
                                          <select  name="q14" id="q14" [(ngModel)]= "adoptionform.q14"
                                          class="form-control" formControlName="q14">
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                          </select>
                                          </div>
                                  </div>
                                 </div>
                                 <div class="row">
                                    <div class="col-sm-12 ">
                                        <div class="form-group">
                                            <label for="q15">Are you comfortable with scheduled house checks from our representative or person from NGO</label>
                                            <select  name="q15" id="q15" [(ngModel)]= "adoptionform.q15"
                                             class="form-control" formControlName="q15">
                                              <option value="yes">Yes</option>
                                              <option value="no">No</option>
                                            </select>
                                            </div>
                                    </div>
                                    </div>
                                    <div class="row">
                                    <div class="col-12" style="font-size:20px">
                                        <div class="form-check">Disclaimer
                                            <label class="form-check-label">
                                              <input class="form-check-input" type="checkbox" value="yes" name='q16'  [(ngModel)]="adoptionform.q16"
                                               class="form-control" formControlName="q16">
                                              I agree </label>

                                          </div>
                                    </div>
                                   </div>
                                   <div class="row" style="margin-bottom: 5px; margin-top: 2px">
                                     <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center" style="margin-top: 3px">
                                      <button class="btn btn-success btn-block" type="submit"  [disabled]="!f.valid">Submit</button>
                                     </div>
                                     <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center" style="margin-top: 3px">
                                        <button class="btn btn-success btn-block" (click)='goBack()'>Cancel</button>
                                      </div>
                                   </div>

        </form>
      </div>
    </div>
  </div>
  <ng-template #uploaded>
      <div class="row">
          <div class="col-6">
            <span style="color: #9b7544; font-style: open-sans; font-size: 22px;  overflow-wrap: break-word;">
                Your Request has Been Sent. He Or She Will Contact Soon
            </span>
          </div>
          <div class="col-6 text-center">
            <button class="btn btn-success" (click)="goBack()">Ok</button>
            </div>
      </div>
  </ng-template>
  <div class="container3 cent" *ngIf=" adoprequestflag === 0 && puserflag === 1;">
    <div class="card">
        <div class="row">
            <div class="col-12 text-center">
                <span style="color:#9b7544; font-style:open sans ; font-size: 20px">
                    You Can't Send Any Adoption request
                </span>
            </div>
        </div>
        <div class="row" style="margin-top:3px">
                <div class="col-12">
                    <button class="btn btn-success btn-block" (click)='goBack()'>Back</button>
                </div>
            </div>
    </div>
  </div>
  <div class="container3 cent" *ngIf=" adoprequestflag === 1 && puserflag === 0;">
        <div class="card">
            <div class="row">
                <div class="col-12 text-center">
                    <span style="color:#9b7544; font-style:open sans ; font-size: 20px">
                          You have already sent Adoption Request for this post.
                    </span>
                </div>
            </div>
            <div class="row" style="margin-top:3px">
                    <div class="col-12 text-center">
                        <button class="btn btn-success2 btn-block" (click)='goBack()'>Back</button>
                    </div>
                </div>
        </div>
      </div>
